export default __webpack_public_path__ + "static/media/twag.27685851.png";